import fp from 'lodash/fp';
import React from 'react';
import { graphql } from 'react-apollo';
import { LinkContainer } from 'react-router-bootstrap';
import { Link } from 'react-router-dom';
import { Button, Container, Table } from 'reactstrap';
import { compose, pure } from 'recompose';
import { routes } from '../../../../constants';
import './artists.css';
import artistsQuery from './artists.gql';

const Artists = ({ data: { artists } }) => (
  <section className='artists'>
    <Container fluid className='mt-3'>
      <LinkContainer to={routes.adminPortal.createArtist}>
        <Button color='primary'>
          Add Artist
        </Button>
      </LinkContainer>
      <Table striped hover>
        <thead>
          <tr>
            <th>Name</th>
          </tr>
        </thead>
        <tbody>
          {
            fp.flow(
              fp.sortBy(({ name }) => name),
              fp.map(({ id, name }) =>
                <tr key={name}>
                  <td>
                    <Link to={routes.adminPortal.artist(id)}>
                      <div>
                        {name}
                      </div>
                    </Link>
                  </td>
                </tr>
              )
            )(artists)
          }
        </tbody>
      </Table>
    </Container>
  </section>
);

export default compose(
  graphql(artistsQuery),
  pure
)(Artists);



// WEBPACK FOOTER //
// ./src/components/pages/admin-portal/artists/artists.js